/* eslint-disable @typescript-eslint/no-explicit-any */
import { InfoWhiteIcon } from '../../assets/svg/MasterCardIcons';
import { UserDataType } from '@rb-serve-app/core';
import { useSelector } from 'react-redux';
import { useProductName } from '@rb-serve-app/core';

type Props = {
  assets: any;
  contentfulData: any;
};

const HorizontalCard = ({ contentfulData, assets }: Props) => {
  const { rewards: rewardsData } = useSelector((state: any) => state.rewards);
  const { accountDetails } = useSelector((state: any) => state?.user);
  const { productName, cardStructure } = useProductName();
  return (
    <div
      data-testid="horizontal-card"
      className="p-4 rounded-lg text-white ipad-portrait:mb-0  
      sm:w-[250px] sm:h-[158px] sm:max-h-[158px] sm:max-w-[250px]
      w-[260px] max-w-[260px] max-h-[164px] h-[164px]
       
        flex flex-col self-center justify-start items-center relative"
      role="group"
      aria-labelledby="card-info"
      style={{
        backgroundImage: `url("${cardStructure?.imgUrl}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <span id="card-info" className="sr-only">
        Card Info
      </span>
    </div>
  );
};

export default HorizontalCard;
